import {Injectable} from '@angular/core';
import {DateTime} from "luxon";
import {Trade} from "../../model/clearing/trade";
import {
  OrderAmendmentTableComponent
} from "../../crystal-clear/data-amendment/order-amendment/table/order-amendment-table.component";
import {FormFieldConfig} from "../../model/api/form-field-config";
import {FieldsService} from "../common/fields-service";
import {AppConfigService} from "../app-config.service";
import {FormFieldGroupConfig} from "../../model/api/form-field-group-config";
import {RolesService} from "../auth/roles.service";
import {OrderAmendmentDataLoadingService} from "./order-amendment-data-loading.service";
import TYPE = FormFieldConfig.TYPE;

@Injectable({
  providedIn: 'root'
})
export class OrderAmendmentFormConfigService {


  constructor(private appConfigService: AppConfigService,
              private fieldsService: FieldsService,
              private rolesService: RolesService,
              private dataLoadingService: OrderAmendmentDataLoadingService) {
  }

  public loadConfig(component: OrderAmendmentTableComponent): FormFieldGroupConfig[] {
    return  [{
      group: '',
      fields: [
        {
          field: 'businessDate',
          column: 0,
          type: TYPE.DATE,
          maxDate: this.rolesService.isAdmin() ? undefined : DateTime.now().minus({days: 1}).toJSDate()
        },
        {
          field: 'moneyOwner',
          column: 0,
          type: TYPE.AUTOCOMPLETE,
          options: () => this.fieldsService.getDistinctOpts(this.dataLoadingService.moneyOwners),
          changed: event => {
            component.tableCurrentRequest.moneyOwner = event.text;
          }
        },
        {
          field: 'customerCode',
          column: 0,
          type: TYPE.AUTOCOMPLETE,
          options: () => this.fieldsService.getDistinctOpts(this.dataLoadingService.customers),
          changed: event => {
            queueMicrotask(() => component.tableCurrentRequest.customerCode = event.text);
          }
        },
        {
          field: 'accountCode',
          column: 0,
          type: TYPE.AUTOCOMPLETE,
          options: () => this.fieldsService.getDistinctOpts(this.dataLoadingService.displayedAccounts),
          changed: event => {
            queueMicrotask(() => component.tableCurrentRequest.accountCode = event.text);
          }
        },
        {
          field: 'reference',
          column: 0,
          type: TYPE.TEXT,
        },
      ]
    }];
  }

}
